(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["split-hero-carousel"] && !Shopify.designMode) return;
  try {
    
function initSplitHeroSwiper(){
  if (typeof window.Swiper === 'undefined') {
    setTimeout(initSplitHeroSwiper, 80);
    return;
  }
  var els = document.querySelectorAll('[data-split-hero-swiper]');
  els.forEach(function(el){
    if (el.dataset.swiperInit) return;
    new window.Swiper(el, {
      loop: true,
      autoplay: { delay: 4000, disableOnInteraction: false, pauseOnMouseEnter: true },
      pagination: { el: el.querySelector('.swiper-pagination'), clickable: true },
      effect: 'fade',
      fadeEffect: { crossFade: true },
      speed: 700,
      grabCursor: true
    });
    el.dataset.swiperInit = '1';
  });
}
document.addEventListener('DOMContentLoaded', initSplitHeroSwiper);
document.addEventListener('shopify:section:load', initSplitHeroSwiper);

  } catch(e) { console.error(e); }
})();
})();
